import { Injectable, Injector, NgModule } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { mergeMap, tap } from 'rxjs/operators';

import { AuthenticationService, ErrorService } from '../index';
import { UnauthorizedInterceptor } from './unauthorized.interceptor';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(public injector: Injector) {}

  shouldAddVersionHeader(url: string) {
    const versionedEndpoints = ['/filter-defaults', '/default-labels'];
    const endpoint = url.substring(url.lastIndexOf('/'));
    return versionedEndpoints.includes(endpoint);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authenticationService = this.injector.get(AuthenticationService);
    const errorService = this.injector.get(ErrorService);

    return authenticationService.getAuthToken().pipe(
      mergeMap((token) => {
        if (token) {
          const clientCode =
            authenticationService.userInfoView &&
            authenticationService.userInfoView.SelectedClient
              ? authenticationService.userInfoView.SelectedClient.ClientCode.toUpperCase()
              : '';
          let authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token.AccessToken}`,
              ClientCode: clientCode,
            },
          });
          if (this.shouldAddVersionHeader(req.url)) {
            authReq = authReq.clone({
              setHeaders: { 'x-version': '2.0' },
            });
          }
          return next.handle(authReq).pipe(
            tap({
              next: (evt) => this.tapThis(errorService, evt),
              error: (error) => this.handleError(errorService, error),
            })
          );
        }

        return next.handle(req).pipe(
          tap({
            next: (evt) => this.tapThis(errorService, evt),
            error: (error) => this.handleError(errorService, error),
          })
        );
      })
    );
  }

  public tapThis = (errorService: ErrorService, evt: any) => {
    if (evt instanceof HttpResponse) {
      if (evt.status !== 200 && evt.status !== 201) {
        const errorResponse = new HttpErrorResponse({
          error: { message: 'An unexpected problem was encountered' },
          status: evt.status,
          statusText: evt.statusText,
        });

        this.handleError(errorService, errorResponse);
      }
    }
  };

  public handleError = (errorService: ErrorService, error: any) => {
    errorService.handleError(error);
  };
}
@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
  ],
})
export class InterceptorModule {}
